import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledInfoLabel = styled.div`
  position: absolute !important;
  display: flex;
  align-items: center;
  bottom: -27px;

  color: ${COLORS.white};

  span {
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
    line-height: 1.67;
    letter-spacing: 0.16px;
    margin-left: 4px;
  }
`;
